import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarNavMenu from "../../components/SidebarNavMenu";
import SidebarItem from "../../../SidebarItem";

import {ReactComponent as SettingIcon} from "assets/img/setting.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function ConfigurationItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    const hasCategoryManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_CATEGORY_MANAGEMENT);
    const hasCancellationReasonAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_CANCELLATION_REASON_MANAGEMENT);
    const hasAttributeManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_ATTRIBUTES_MANAGEMENT);
    const hasShippingMethodAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_SHIPPING_METHODS_MANAGEMENT);
    const hasOrganizationEshopManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.GLOBAL_ORGANIZATION_ESHOP_MANAGEMENT);
    const hasOrganizationManagementAuthorization = hasAuthorization(currentMemberAuthorizations, Authorizations.GLOBAL_ORGANIZATION_MANAGEMENT);

    if (
        !hasCategoryManagementAuthorization
        && !hasCancellationReasonAuthorization
        && !hasAttributeManagementAuthorization
        && !hasShippingMethodAuthorization
        && !hasOrganizationEshopManagementAuthorization
        && !hasOrganizationManagementAuthorization
    ) {
        return null;
    }

    const pathAuthMap = {
        [MarketplaceRoutes.ATTRIBUTES]: hasAttributeManagementAuthorization,
        [MarketplaceRoutes.CATEGORIES]: hasCategoryManagementAuthorization,
        [MarketplaceRoutes.BRANDS]: hasOrganizationEshopManagementAuthorization,
        [MarketplaceRoutes.GENDERS]: hasOrganizationEshopManagementAuthorization,
        [MarketplaceRoutes.SECTORS]: hasOrganizationEshopManagementAuthorization,
        [MarketplaceRoutes.CANCELLATION_REASONS]: hasCancellationReasonAuthorization,
        [MarketplaceRoutes.SHIPPING_METHODS]: hasShippingMethodAuthorization,
        [MarketplaceRoutes.INVOICE_NUMBERING]: hasOrganizationManagementAuthorization,
    };

    const Item = ({path}) => {
        if (!path) {
            return null;
        }

        const isAuthorized = pathAuthMap[path];

        if (!isAuthorized) {
            return null;
        }

        const isSelected = currentPath.startsWith(path);

        return (
            <SidebarItem
                to={path}
                selected={isSelected}
            >
                <FormattedMessage id={`sidebar.item.${path.replace('/', '')}`}/>
            </SidebarItem>
        )
    };

    const isConfigurationTabShouldStayOpen = Object.keys(pathAuthMap).some(path => currentPath.startsWith(path));

    return (
        <SidebarNavMenu
            open={isConfigurationTabShouldStayOpen}
            icon={<SettingIcon />}
            content={<FormattedMessage id='sidebar.app.configuration' />}
        >
            {Object.keys(pathAuthMap).map((path) => <Item key={path} path={path} /> )}
        </SidebarNavMenu>
    );
}

export default ConfigurationItem;
